const Space = ({ s }) => {
    return <div style={{ marginBottom: `${s}px` }} />;
};

export default Space;
